export const FETCH_PROJET_CONTRAT = 'FETCH_PROJET_CONTRAT'
export const GET_PROJET_CONTRAT = 'GET_PROJET_CONTRAT'
export const FETCH_SITUATION = 'FETCH_SITUATION'
export const UPDATE_SITUATION = 'UPDATE_SITUATION'
export const ADD_PROJECT_Quittance = 'ADD_PROJECT_Quittance'

